// import { } from '@sharpengine-ui/sharpengine-ui/';

export default function DownloadsPage() {
  return (
    <div className="pt-20 px-6">
      <h1 className="text-white text-4xl font-bold">Downloads</h1>
    </div>
  );
}